/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { SearchableItem, SearchableSelectionType } from 'src/app/model/interface';
import {IbisData} from './ibis-data';

export class IbisReport implements SearchableItem {

  constructor(values: any = {}) {
    Object.assign(this, values);

    if (values.DATA) {
      this.DATA = new IbisData(values.DATA);
    }
    else {
      this.DATA = new IbisData();
    }
  }
  ID: number;
  CODE: string;
  DATE: string; // 10-2019
  NAME: string;
  VERSION: number;
  FILE_EXIST: boolean = false;

  // Is Report is draft
  DRAFT: boolean = false;

  // Data in Database for v.DB
  DATA: IbisData;

  // Helpers
  RECENT = false;
  active: boolean;
  allowed: boolean;

  /**
   * TODO: Annotate please
   * */
  public static createNewIbisWithData() {
    const ibis = new IbisReport();
    ibis.DATA = new IbisData();

    return ibis;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static parseArray(json: any[], recent: boolean = false): IbisReport[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new IbisReport(j));
        }
      }
    }
    IbisReport.markRecent(arr);
    return arr;
  }

  private static markRecent(reports: IbisReport[]): void {
    for (const r of reports) {
      r.RECENT = IbisReport.isMostRecent(r, reports);
    }
  }

  private static isMostRecent(report: IbisReport, reports: IbisReport[]): boolean {
    let returnValue: boolean = !!report.DATE;
    for (const r of reports) {
      if (r.DATE && report.DATA && report.CODE.trim() === r.CODE.trim() && report.DATE != r.DATE) {
        const reportDate = new Date(report.DATE.split('-')[0] + '-01-' + report.DATE.split('-')[1]);
        const rDate = new Date(r.DATE.split('-')[0] + '-01-' + r.DATE.split('-')[1]);
        if (rDate > reportDate) {
          returnValue = false;
        }
      }
    }
    return returnValue;
  }

  getName(): string {
    return `<div class="left-panel">${this.CODE}_v${this.VERSION !== 0 ? this.VERSION : 'DB'} - ${this.NAME}</div><div class="right-panel ${!this.DATE ? 'not-available-date' : ''}"><span class="${this.DRAFT ? 'draft' : 'd-none'}">${this.DRAFT ? 'Draft' : ''}</span><span class="${this.RECENT ? 'recent' : ''}">${this.RECENT ? 'recent' : ''}</span>${this.DATE ? this.DATE : 'N/A'}</div>`;
  }

  getFullDetails(): string {
    return `<div class="left-panel">${this.CODE}_v${this.VERSION !== 0 ? this.VERSION : 'DB'} - ${this.NAME}</div><div class="right-panel ${!this.DATE ? 'not-available-date' : ''}"><span class="${this.DRAFT ? 'draft' : 'd-none'}">${this.DRAFT ? 'Draft' : ''}</span><span class="${this.RECENT ? 'recent' : ''}">${this.RECENT ? 'recent' : ''}</span>${this.DATE ? this.DATE : 'N/A'}</div>`;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }

  private getDateValue(): number {
    if (this.DATE.indexOf('-') > -1) {
      const split = this.DATE.split('-');
      return Number(split[0]) + Number(split[1]);
    } else { return 0; }
  }
}
